import React, { FC, useState } from 'react';
import cnBind from 'classnames';
import { GxCheckbox } from '@garpix/garpix-web-components-react';
import dayjs from 'dayjs';
import styles from './styles/index.module.scss';
import { DAYS_WEEK_TASK, MONTH_WEEK_TASK } from '../../../const';
import Input from '../../../../../components/Input';

interface IModalChangeTaskRepeat {
  currentTask: any;
}

const cn = cnBind.bind(styles);
const ModalChangeTaskFooter: FC<IModalChangeTaskRepeat> = ({ currentTask }) => {
  const [tabGroups, setTabGroups] = useState<any>({
    reminderTab: { status: false },
    repeatTab: { status: false },
  });

  const handleClickTab = (name: string) => {
    setTabGroups({
      ...tabGroups,
      [name]: { status: !tabGroups[name].status },
    });
  };

  return (
    <div
      className={cn({
        repeat: true,
        'repeat--active': tabGroups.reminderTab.status,
      })}
    >
      <div className={styles['repeat__container']}>
        <h2>Напоминание</h2>
        <p
          className={styles['repeat__container--text']}
          onClick={() => handleClickTab('reminderTab')}
        >
          {tabGroups.reminderTab.status ? 'Свернуть' : 'Развернуть'}
        </p>
      </div>
      {tabGroups.reminderTab.status && (
        <div className={styles['container']}>
          <div className={styles['wrapper']}>
            <div className={styles['form-item']}>
              <div
                className={cn(styles['form-item__group'], styles['checkbox'])}
              >
                <label
                  className={styles['form-item--label']}
                  style={{ whiteSpace: 'nowrap' }}
                  htmlFor='customer'
                >
                  Напоминание:
                </label>
                <GxCheckbox checked={currentTask.is_remind} disabled />
              </div>
            </div>
            <div className={styles['form-item']}>
              <div className={styles['form-item__group']}>
                <label
                  className={styles['form-item--label']}
                  style={{ whiteSpace: 'nowrap' }}
                  htmlFor='customer'
                >
                  Дата и время:
                </label>
                <Input
                  value={
                    currentTask.remind_at
                      ? dayjs(currentTask.remind_at).format('YYYY.MM.DD HH:mm')
                      : undefined
                  }
                  disabled
                  className={cn(styles['form-item--input'])}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <div className={styles['repeat__container']}>
        <h2>Повторяемость</h2>
        <p
          className={styles['repeat__container--text']}
          onClick={() => handleClickTab('repeatTab')}
        >
          {tabGroups.repeatTab.status ? 'Свернуть' : 'Развернуть'}
        </p>
      </div>
      {tabGroups.repeatTab.status && (
        <div className={styles['container']}>
          <div className={styles['wrapper']}>
            <div
              className={cn(styles['form-item'], styles['form-item__wrapper'])}
            >
              <div
                className={cn(
                  styles['form-item__group'],
                  styles['form-item__group--left-block']
                )}
              >
                <label
                  className={styles['form-item--label']}
                  style={{ whiteSpace: 'nowrap' }}
                  htmlFor='customer'
                >
                  Время:
                </label>
                <Input
                  value={dayjs(currentTask.repeat_time_at, 'HH:mm:ss').format(
                    'HH:mm:ss'
                  )}
                  disabled
                  className={cn(styles['form-item--input'], styles['date'])}
                />
              </div>
              <div
                className={cn(
                  styles['form-item__group'],
                  styles['form-item__group--right-block']
                )}
              >
                <label
                  className={cn(
                    styles['form-item--label'],
                    styles['count--label']
                  )}
                  htmlFor='customer'
                >
                  Кол-во повторений:
                </label>
                <Input
                  value={currentTask.repeat_count_remain}
                  disabled
                  className={cn(styles['form-item--input'], styles['count'])}
                />
              </div>
            </div>
            <div className={styles['form-item']}>
              <div className={styles['form-item__group']}>
                <label
                  className={styles['form-item--label']}
                  htmlFor='customer'
                >
                  Месяц:
                </label>
                <div className={styles['list']}>
                  {currentTask.repeat_month.split(',').map((item: any) => (
                    <div key={item} className={styles['list__item']}>
                      {MONTH_WEEK_TASK[Number(item) - 1].label}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className={styles['form-item']}>
              <div className={styles['form-item__group']}>
                <label
                  className={styles['form-item--label']}
                  htmlFor='customer'
                >
                  Дни недели:
                </label>
                <div className={styles['list']}>
                  {currentTask.repeat_dow.length > 0 && (
                    <>
                      {currentTask.repeat_dow.split(',').map((item: any) => (
                        <div key={item} className={styles['list__item']}>
                          {DAYS_WEEK_TASK[Number(item) - 1].label}
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className={styles['form-item']}>
              <div className={styles['form-item__group']}>
                <label
                  className={styles['form-item--label']}
                  htmlFor='customer'
                >
                  Числа:
                </label>
                <div className={styles['list']}>
                  {currentTask.repeat_day.length > 0 && (
                    <>
                      {currentTask.repeat_day.split(',').map((item: any) => (
                        <div key={item} className={styles['list__item']}>
                          {item}
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModalChangeTaskFooter;
